import { ADD_RELEASE_NOTE, DELETE_RELEASE_NOTE, SET_RELEASE_NOTES_DATA, UPDATE_RELEASE_NOTE } from "./actionType";

const INIT_STATE = {
  data: [],
  total: 0,
};

const ReleaseNotes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_RELEASE_NOTES_DATA:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
      };

    case ADD_RELEASE_NOTE:
      return {
        ...state,
        data: [action.payload, ...state.data],
        total: state.total + 1,
      };
    case UPDATE_RELEASE_NOTE:
      const existingIndex = state.data.findIndex((item) => item.id === action.payload.id);
      const updatedData = state.data;
      if (existingIndex !== -1) {
        updatedData[existingIndex] = action.payload;
      }
      return {
        ...state,
        data: updatedData,
      };
    case DELETE_RELEASE_NOTE:
      return {
        ...state,
        data: [...state.data.filter((item) => item.id !== action.payload)],
        total: state.total - 1,
      };
    default:
      return { ...state };
  }
};

export default ReleaseNotes;
